import {
  FETCH_TASK,
  FETCH_TASK_SUCCESS,
  FETCH_TASK_FAILURE,
  FETCH_PROJECT_MODULE,
  FETCH_PROJECT_MODULE_SUCCESS,
  FETCH_PROJECT_MODULE_FAILURE, 
  FETCH_PROJECT_MODULE_CLEAR, 
  SAVE_TASK,
  SAVE_TASK_SUCCESS,
  SAVE_TASK_FAILURE,
  CHANGE_TASK_STATUS,
  CHANGE_TASK_STATUS_SUCCESS,
  CHANGE_TASK_STATUS_FAILURE
} from "./actionTypes";

// Fetch Module
export const fetchTask = (payload) => ({
  type: FETCH_TASK,
  payload: payload
});

export const fetchTaskSuccess = (roles) => ({
  type: FETCH_TASK_SUCCESS,
  payload: roles,
});

export const fetchTaskFailure = (error) => ({
  type: FETCH_TASK_FAILURE,
  payload: error,
});

export const fetchProjectModule = (payload) => ({
  type: FETCH_PROJECT_MODULE,
  payload: payload
});

export const fetchProjectModuleSuccess = (roles) => ({
  type: FETCH_PROJECT_MODULE_SUCCESS,
  payload: roles,
});

export const fetchProjectModuleFailure = (error) => ({
  type: FETCH_PROJECT_MODULE_FAILURE,
  payload: error,
});

export const fetchProjectModuleClear = () => ({
  type: FETCH_PROJECT_MODULE_CLEAR,
  payload: '',
});

// Create Project
export const saveTask = (formData, isEdit) => ({
  type: SAVE_TASK,
  payload: { formData, isEdit },
});

export const saveTaskSuccess = (response) => ({
  type: SAVE_TASK_SUCCESS,
  payload: response,
});

export const saveTaskFailure = (error) => ({
  type: SAVE_TASK_FAILURE,
  payload: error,
});

export const changeTaskStatus = (payload) => ({
  type: CHANGE_TASK_STATUS,
  payload,
});

export const changeTaskStatusSuccess = (response) => ({
  type: CHANGE_TASK_STATUS_SUCCESS,
  payload: response,
});

export const changeTaskStatusFailure = (error) => ({
  type: CHANGE_TASK_STATUS_FAILURE,
  payload: error,
});

